import { Factory } from 'miragejs';

export default Factory.extend({
  entryCreatedCount: 2,
  granteeEmails: 'john+sf@doe.com,john@doe.com',
  inviteCreatedcount: 1,
  signOutcount: 0,
});
